import { InjectionToken } from '@angular/core';

export const POS_ID = new InjectionToken<string>('POS_ID');
